import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, from, of, BehaviorSubject } from "rxjs";
import { shareReplay, takeUntil, tap, map, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LogCategory, LoggerService, LogService, LogType } from '../core/services/logger.service';


@Injectable({
  providedIn: 'root'
})
export class KudosService {

    private kudosApiUrl: string = environment.apiUrl + '/kudos';

    constructor(
        private http: HttpClient,        
        private logger: LoggerService
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Service, LogService.Kudos, category);
    }

    private refreshSubject$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    // All the kudos for the current user
    public myKudos$: Observable<any[]> = this.refreshSubject$
        .pipe(
            switchMap( () => this.http.get<any>(this.kudosApiUrl + '/self') ),
            tap((data: any[]) => {
                this.log('myKudos$', 'Fetched kudos for current user', LogCategory.SubscriptionData);
            }),
            shareReplay(1)
        );

    public newKudos$: Observable<any[]> = this.myKudos$.pipe(
        tap((data: any[]) => {
            this.log('newKudos$', 'Filtered new kudos', LogCategory.SubscriptionData);
        }),
        map((data: any[]) => {            
            return data.filter(a => a.Status == 'New');
        })
    );

    // All the kudos for the current user
    //public myKudos$: Observable<any[]> = this.http.get<any>(this.kudosApiUrl + '/self')
    //    .pipe(
    //        tap((data: any[]) => {
    //            this.log('myKudos$', 'Fetched kudos for current user', LogCategory.SubscriptionData);
    //        }),
    //        shareReplay(1)
    //);

    // Submits a new kudo from the current to the given user. The kudo should contain the following:
    public submitKudo$(toPersonId: number, message: string, isAnon: boolean) : Observable<any> {

        const url = `${this.kudosApiUrl}/${toPersonId}`;

        const kudo = {
            Message: message,
            IsAnon: isAnon,
        }

        // No need to unsubscribe from finite observables like http 
        return this.http
            .post<any>(url, kudo); 
    }

    // Updates an existing Kudo by changing its status 
    public updateKudo(kudo: any, newStatus: string) {

        const url = `${this.kudosApiUrl}/self`;

        kudo.Status = newStatus; 

        // No need to unsubscribe from finite observables like http 
        return this.http
            .patch<any>(url, kudo)
            .subscribe(
                () => {
                    this.log("updateKudo", `updated kudo to ${kudo.Status}`, LogCategory.SubscriptionData);
                    this.refreshSubject$.next(true); 
                },
                error => this.log("updateKudo", error, LogCategory.SubscriptionData)
        );
    }
}
